import Cookies from "js-cookie";
import { useEffect } from "react";
import { CookiesKey } from "@/types/cookies";
import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { IQuestionOptions } from "@/types";
import { Radio } from "@/pages/quiz/15000/components/Radio";
import { Button } from "@/pages/quiz/15000/components/Button";
import { Textarea } from "@/pages/quiz/15000/components/Textarea";

type IProps = {
  answer: string;
  inputValue?: string;
};

const trackEverflowConsentEvent = (label: string) => {
  if (!label?.toUpperCase()?.includes("I CONSENT")) return;
};

const SingleChoiceQuestion = ({
  question,
  questionValue,
  setQuestionAnswer,
  setQuestionValue,
}: QuizQuestionProps<IProps>) => {
  const { options } = question.attributes;

  useEffect(() => {
    if (typeof questionValue === "string") {
      setQuestionValue({
        answer: questionValue,
      });
    }
  }, [questionValue]);

  const selectedOption = options?.find(
    (option) => option.value === questionValue.answer
  );

  const hasInnerBlock = !!selectedOption?.innerBlock;
  const hasNoPendingInnerBlocks =
    !hasInnerBlock || !!questionValue.inputValue?.trim();
  const innerBlockLabel = selectedOption?.innerBlock?.label || "";
  const inputValue = questionValue.inputValue || "";

  const handleChange = (value: string) => {
    const questionValueBySelectedValue =
      questionValue?.answer === value ? questionValue : null;

    const newQuestionValue = {
      ...questionValueBySelectedValue,
      answer: value,
    };

    // const canSubmitAnswer = !options?.find((option) => option.value === value)
    //   ?.innerBlock;

    // if (canSubmitAnswer) {
    //   setQuestionAnswer(newQuestionValue);
    // } else {
    setQuestionValue(newQuestionValue);
    // }
  };

  const handleOptionClick = (option: IQuestionOptions) => {
    trackEverflowConsentEvent(option.label);

    handleChange(option.value);
  };

  const handleTextareaInputChange = (value: string) => {
    setQuestionValue({
      ...(questionValue || {}),
      inputValue: value,
    });
  };

  return (
    <>
      <div key={question.id}>
        <div className="mt-4 flex flex-col space-y-1">
          {options?.map(({ value, label, ...optionRest }, index) => (
            <Radio
              key={`${value}-${index}`}
              label={label}
              value={value}
              checked={questionValue?.answer === value}
              onClick={() => handleOptionClick({ value, label, ...optionRest })}
              className="first:rounded-t-2xl last:rounded-b-2xl"
            />
          ))}
        </div>

        {hasInnerBlock && (
          <div className="flex flex-col gap-6 mt-4">
            {innerBlockLabel && (
              <div className="text-new-design-gray-500 text-2xl font-medium">
                {innerBlockLabel}
              </div>
            )}
            <Textarea
              placeholder={
                selectedOption?.innerBlock?.placeholder || "Type here..."
              }
              minRows={4}
              maxRows={4}
              value={inputValue}
              onChange={(e) => handleTextareaInputChange(e.target.value)}
              className="w-full"
              autoFocus={!inputValue?.trim()}
            />
          </div>
        )}
      </div>

      <Button
        disabled={!questionValue?.answer || !hasNoPendingInnerBlocks}
        onClick={() => setQuestionAnswer(questionValue)}
      />
    </>
  );
};

export { SingleChoiceQuestion };
